import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { ReactComponent as flow1 } from "../../../assets/icons/flow1.svg";
import { ReactComponent as flow2 } from "../../../assets/icons/flow2.svg";
import { ReactComponent as flow3 } from "../../../assets/icons/flow3.svg";
import { ReactComponent as flow4 } from "../../../assets/icons/flow4.svg";
import { ReactComponent as flow5 } from "../../../assets/icons/flow5.svg";
 
const steps = [
  {
    no: "01",
    icon: flow1,
    title: "ヒアリング",
    text: "課題・ご要望、M365のご利用状況をヒアリング",
  },
  {
    no: "02",
    icon: flow2,
    title: "ご提案＆簡易デモ",
    text: "画面イメージとSPFxのサンプルデモをご提示",
  },
  {
    no: "03",
    icon: flow3,
    title: "ご契約",
    text: "要件定義と仕様を固め正式にご契約",
  },
  {
    no: "04",
    icon: flow4,
    title: "開発＆納品",
    text: "構築・テストを実施し本番環境へデプロイ",
  },
  {
    no: "05",
    icon: flow5,
    title: "保守・運用サポート",
    text: "問い合わせ対応、機能追加・カスタマイズに対応",
  },
];
 
const UsageFlow = () => {
  return (
    <Box sx={{ backgroundColor: "#fff", py: { xs: 6, md: 8 } }}>
      <Container maxWidth={false} sx={{ width: "92%", mx: "auto" }}>
        <Typography
          sx={{
            color: "#FF6000",
            fontWeight: 700,
            fontSize: "13px",
            letterSpacing: "1px",
            mb: 1,
          }}
        >
          FLOW
        </Typography>
 
        <Typography
          sx={{ fontWeight: 700, fontSize: { xs: "26px", md: "50px" }, mb: 1 }}
        >
          ご利用の流れ
        </Typography>
 
        <Typography
          sx={{
            fontSize: "20px",
            color: "rgba(0,0,0,0.65)",
            mb: { xs: 4, md: 5 },
          }}
        >
          初回ヒアリングから納品・運用まで、専任チームが伴走します
        </Typography>
 
        {/* Number row with connecting lines */}
        <Box
          sx={{
            display: { xs: "none", md: "grid" },
            gridTemplateColumns: "repeat(5, 1fr)",
            gap: 2,
            alignItems: "center",
            mb: 1,
          }}
        >
          {steps.map((step, index) => (
            <Box
              key={step.no}
              sx={{
                position: "relative",
                textAlign: "center",
                "&::after":
                  index < steps.length - 1
                    ? {
                        content: '""',
                        position: "absolute",
                        top: "50%",
                        left: "calc(100% + 8px)",
                        width: "100px",
                        height: "1px",
                        backgroundColor: "rgba(0,0,0,0.15)",
                        transform: "translate(-50%, -50%)",
                        zIndex: 0,
                      }
                    : undefined,
              }}
            >
              <Typography
                sx={{
                  position: "relative",
                  zIndex: 1,
                  display: "inline-block",
                  backgroundColor: "#fff",
                  px: 1,
                  fontWeight: 700,
                  fontSize: "48px",
                  color: "#FF6000",
                }}
              >
                {step.no}
              </Typography>
            </Box>
          ))}
        </Box>
 
        {/* Mobile / tablet cards (own number shown inside the card) */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, 1fr)",
              md: "repeat(5, 1fr)",
            },
            gap: { xs: 3, md: 0 },
          }}
        >
          {steps.map((step) => {
            const StepIcon = step.icon;
            return (
              <Box
                key={step.no}
                sx={{
                  position: "relative",
                  border: "1px solid rgba(0,0,0,0.1)",
                  p: 2.5,
                  textAlign: "center",
                  display: { xs: "block", md: "none" },
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "50%",
                    height: "2px",
                    backgroundColor: "#FF6000",
                  },
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: "22px",
                    color: "#FF6000",
                    mb: 1,
                  }}
                >
                  {step.no}
                </Typography>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mx: "auto",
                    mb: 1.5,
                  }}
                >
                  <StepIcon sx={{ color: "#FF6000", fontSize: 24 }} />
                </Box>
                <Typography sx={{ fontWeight: 700, fontSize: "18px", mb: 1 }}>
                  {step.title}
                </Typography>
                <Typography
                  sx={{ fontSize: "16px", color: "rgba(0,0,0,0.6)", lineHeight: 1.7 }}
                >
                  {step.text}
                </Typography>
              </Box>
            );
          })}
        </Box>
 
        {/* Desktop card row (aligned under the number row) */}
        <Box
          sx={{
            display: { xs: "none", md: "grid" },
            gridTemplateColumns: "repeat(5, 1fr)",
            gap: 2,
          }}
        >
          {steps.map((step) => {
            const StepIcon = step.icon;
            return (
              <Box
                key={step.no}
                sx={{
                  position: "relative",
                  border: "1px solid rgba(0,0,0,0.1)",
                  borderRadius: "6px",
                  padding: "35px 20px",
                  textAlign: "center",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "50%",
                    height: "2px",
                    backgroundColor: "#FF6000",
                  },
                }}
              >
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mx: "auto",
                    mb: 1.5,
                  }}
                >
                  <StepIcon sx={{ color: "#FF6000", fontSize: 24 }} />
                </Box>
                <Typography sx={{ fontWeight: 700, fontSize: "18px", mb: 1 }}>
                  {step.title}
                </Typography>
                <Typography
                  sx={{ fontSize: "16px", color: "rgba(0,0,0,0.6)", lineHeight: 1.7 }}
                >
                  {step.text}
                </Typography>
              </Box>
            );
          })}
        </Box>
      </Container>
    </Box>
  );
};
 
export default UsageFlow;